/**
 * @author       david.loehr@zumper.com (David Loehr)
 * @copyright    Copyright (c) 2023, Zumper
 */

import { type TitleCase, capitalize } from '@zcode/utils'
import { type EnumLabel, getEnumLabel } from './getEnumLabel'

export type WordCase<S extends string> = S extends `${infer Start}_${infer End}`
  ? `${Start} ${WordCase<End>}`
  : S

export type EnumTitle<
  Enum extends object,
  EnumValue extends (Enum[keyof Enum] | keyof Enum) & (number | string),
> = TitleCase<WordCase<EnumValue extends number ? EnumLabel<Enum, EnumValue> : EnumValue>>

function wordCase<S extends string>(snakeCaseString: S): WordCase<S> {
  return snakeCaseString.replace(/_/g, ' ') as WordCase<S>
}

export function getEnumTitle<
  Enum extends object,
  EnumValue extends (Enum[keyof Enum] | keyof Enum) & (number | string),
>(enoom: Enum, value: EnumValue): EnumTitle<Enum, EnumValue> {
  if (typeof value === 'number') {
    // @ts-expect-error
    return capitalize(wordCase(getEnumLabel(enoom, value)))
  }
  // @ts-expect-error
  return capitalize(wordCase(value))
}
